import {listSupplierOffersSearchSchema} from "@project/application/engineering/supplier-offers";
import {createFileRoute, useParams} from "@tanstack/react-router";
import {routeMessages} from "../../../../../../messages/routes.messages";
import {Route as ServiceRoute} from "../route";
import {ServiceOffersPage} from "./-page/service-offers.page";

export const Route = createFileRoute("/_app/engineering/services/$serviceId/offers/")({
  component: RouteComponent,
  staticData: {meta: {labelDescriptor: routeMessages.offers}},
  validateSearch: (search) => listSupplierOffersSearchSchema.parse(search),
});
function RouteComponent() {
  const {serviceId} = useParams({strict: false}) as {serviceId: string};
  const {includeDeleted} = ServiceRoute.useSearch();
  return <ServiceOffersPage serviceId={serviceId} includeDeleted={includeDeleted} />;
}
